import { render } from "./HomeP.vue?vue&type=template&id=96ad397e&scoped=true"
import script from "./HomeP.vue?vue&type=script&lang=js"
export * from "./HomeP.vue?vue&type=script&lang=js"

import "./HomeP.vue?vue&type=style&index=0&id=96ad397e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ad397e"]])

export default __exports__